// extracted by mini-css-extract-plugin
export var fullWidthButton = "_eh-0";